import { memo } from 'react';

import InputWithOverlay from '@ui/input-with-overlay/input-with-overlay';

type TEditFirstNameProps = {
  firstName: string;
  onChange: (value: string) => void;
};

const EditFirstName = memo(({ firstName, onChange }: TEditFirstNameProps) => {
  return (
    <label htmlFor="firstName" className="flex-1 flex-column gap-4 width-100-percent">
      <InputWithOverlay
        label="First name *"
        dirtyError={({ dirty, setHasError }) => {
          const hasError = dirty && !firstName?.trim().length;
          setHasError(hasError);
        }}
        designSize="medium"
        inputProps={{
          id: 'firstName',
          value: firstName,
          onChange: (e) => onChange(e.target.value),
          placeholder: 'Add name',
        }}
      />
    </label>
  );
});

EditFirstName.displayName = 'EditFirstName';

export default EditFirstName;
